import { formatPrice, formatCPM, formatBigNumber } from "../../../utils/Utils";
import Payments from "../../../libs/API/Payments";
import Auth from "../../../libs/API/Auth";


class CampaignPlanningConfirmationSummary {
    constructor() {
        this.main = document.getElementById('campaign_planning_confirmation_summary');

        this._notificationPendingPayment = this.main.querySelector('.order-summary-notification-pending-payment');

        this._rowDigital = this.main.querySelector('.row_total_digital');
        this._rowStatic = this.main.querySelector('.row_total_static');

        this._totalCountStatic = this.main.querySelector('.total_count_static');
        this._totalCountDigital = this.main.querySelector('.total_count_digital');

        this._totalPriceStatic = this.main.querySelector('.total_price_static');
        this._totalPriceDigital = this.main.querySelector('.total_price_digital');
        this._totalPrice = this.main.querySelector('.total_price');

        this._rowAdBuilder = this.main.querySelector('.row_ad_builder');
        this._adBuilderCredits = this.main.querySelector('.ai_credits');
        this._adBuilderPrice = this.main.querySelector('.ai_credits_price');

        Auth.addEventListener('sessionReady', (logged) => {
            if (logged) {
                Payments.getPaymentsList({ "filter[status]": 'pending', page_size: 1 }).then(data => {
                    if (data.items.length > 0) {
                        if (this._notificationPendingPayment) this._notificationPendingPayment.classList.remove('d-none');
                    }
                });
            }
        });
    }

    set loading(value) {
        if (value) {
            this.main.classList.add('skeleton--show');
        } else {
            this.main.classList.remove('skeleton--show');
        }
    }

    set(data) {
        this.loading = true;
        if (data.static.billboard_count < 1) {
            this._rowStatic.classList.add('d-none');
        } else {
            this._totalCountStatic.innerHTML = data.static.billboard_count;
            this._totalPriceStatic.innerHTML = formatPrice(data.static.price);
        }

        if (data.digital.billboard_count < 1) {
            this._rowDigital.classList.add('d-none');
        } else {
            this._totalCountDigital.innerHTML = data.digital.billboard_count;
            this._totalPriceDigital.innerHTML = formatPrice(data.digital.price);
        }

        if (data.ai_credits != null) {
            this._rowAdBuilder.classList.remove('d-none');
            this._adBuilderCredits.innerHTML = data.ai_credits.amount;
            this._adBuilderPrice.innerHTML = formatPrice(data.ai_credits.price);
        } else {
            this._rowAdBuilder.classList.add('d-none');
        }

        this._totalPrice.innerHTML = formatPrice(data.total.price);
        this.loading = false;
    }
}

export default CampaignPlanningConfirmationSummary;